module.exports = __webpack_public_path__ + "static/media/bg5.d7d1aaf7.jpg";